export default __webpack_public_path__ + "static/media/fp_card.34cabd0b.png";